import React, { useRef } from "react";

import { groupBy } from "es-toolkit";

import { Sidebar } from "@/components/sidebar";
import { type Item } from "@/components/sidebar/ComboButton";
import { useRovingNav } from "@/utils/useRovingNav";

type Props = {
  items: (Item | Item[])[];
  /**
   * Predicate function that splits an array of items into two arrays.
   */
  onSelect?: (item: Item) => void;
  className?: string;
  /** Names the group: one Tab stop, Left/Right/Home/End between its buttons */
  label: string;
};

export function ActionsPalette({ items, onSelect, className, label }: Props) {
  const groupRef = useRef<HTMLDivElement>(null);
  useRovingNav(groupRef, "horizontal");

  const sections = groupBy(items, (item) => {
    const firstItem = Array.isArray(item) ? item[0] : item;
    return firstItem.groupIndex || 0;
  });

  return (
    <div ref={groupRef} role="group" aria-label={label} className={className}>
      {Object.values(sections).map((section, sectionIndex) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={sectionIndex}>
          <div className="grid grid-cols-6 gap-[6px]">
            {section.map((item, itemIndex) => {
              const comboItems = Array.isArray(item) ? item : [item];
              return (
                <Sidebar.ComboButton
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${comboItems[0].title}-${itemIndex}`}
                  items={comboItems}
                  className="col-span-1 aspect-[1] text-size-18"
                  nestedButtonClassName="text-size-18"
                  itemsClassName="font-mono"
                  onItemSelect={onSelect}
                />
              );
            })}
          </div>
          {sectionIndex !== Object.values(sections).length - 1 && (
            <Sidebar.Delimiter className="my-1" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
